const sessionsEnabled = () => !!process.env.NEXT_PUBLIC_USE_SESSIONS

export default sessionsEnabled
